import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { BaseService } from 'src/app/services/base.service';
import { MatDialog } from '@angular/material/dialog';
import * as feather from 'feather-icons';
import { ConfirmationdialogComponent } from '../shared/confirmationdialog/confirmationdialog.component';
import { pageList } from './setup.const';
import { environment } from 'src/environments/environment';
import { UtilService } from '../services/util.service';
import { AuthenticationService } from '../services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.css']
})
export class SetupComponent implements OnInit, AfterViewInit {
  @ViewChild('closeUser') closeUser;
  @ViewChild('closeRole') closeRole;
  public usersList: any;
  public rolesList: any;
  public organizationList: any;
  public successmsg: any;
  public warningmsg: any;
  public messagecont: any;
  public isLoading: any;
  public isModalLoading: any;
  public isUserCreate: any;
  public isRoleCreate: any;
  public userId: any;
  public roleId: any;
  public pageList: any;
  public userDetails: object;
  public currentUserRole: string;
  public currentUserEmail: string;
  public currentUserId: string;
  public currentUserName: string;
  public currentOrganizationId: number;
  enablePass = true;
  userData = { first_name: '', last_name: '', phone: '', email: '', org_name: '', username: '', role_id: '', status: true, org_id: '' };
  roleData = { user_role: '', description: '', status: true };
  private readonly baseUrl = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    public translate: TranslateService,
    public authentication: AuthenticationService,
    public baseService: BaseService,
    public dialog: MatDialog,
    public utliService: UtilService) { }

  ngOnInit() {
    console.log('authentication', this.authentication);
    this.currentUserRole = this.authentication.role;
    this.currentUserEmail = this.authentication.userEmail;
    this.currentOrganizationId = this.authentication.orgId ;
    this.currentUserId = this.authentication.userId.toString();
    this.currentUserName = this.authentication.userName;
    this.userDetails = {
      userEmail: this.currentUserEmail,
      userID: this.currentUserId,
      userName: this.currentUserName,
      organizationId: this.currentOrganizationId,
    };
    this.getPageList();
    this.pageList = pageList;
    this.userId = '';
    this.roleId = '';
    this.isLoading = true;
    this.isModalLoading = false;
    this.successmsg = false;
    this.warningmsg = false;
    this.isUserCreate = true;
    this.isRoleCreate = true;
    this.getUsers();
    this.getRoles();
    this.getOrganizations();
  }

  getPageList() {
    const headerMenu = environment.accessConfig.headerMenu;
    if (headerMenu && headerMenu.length > 0) {
      this.pageList = pageList.filter((x) => headerMenu.includes(x.name));
    }
  }

  ngAfterViewInit() {
    feather.replace();
  }

  hasAccess(page) {
    return this.authentication.hasAccess(page);
  }

  enablePassword(event) {
    this.enablePass = event.target.checked;
  }

  getUsers() {
    this.isLoading = true;
    const url = `${this.baseUrl}users?userDetails=${encodeURIComponent(JSON.stringify(this.userDetails))}`;

    this.httpClient.get<any>(url)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe((response) => {
        this.isLoading = false;
        this.usersList = response.data;
      });
  }

  getRoles() {
    this.isLoading = true;
    const url = `${this.baseUrl}roles?userDetails=${encodeURIComponent(JSON.stringify(this.userDetails))}`;

    this.httpClient.get<any>(url)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe((response) => {
        this.rolesList = response.data.map((rolesData) => {
          pageList.forEach((pageData) => {
            if (rolesData.permissions && rolesData.permissions !== null && !rolesData.permissions[pageData.name]) {
              rolesData.permissions[pageData.name] = {...pageData};
            }
          });
          return rolesData;
        });
        // this.rolesList = response.data;
      });
  }
  
  getOrganizations() {
    this.isLoading = true;
    const url = `${this.baseUrl}organizations`;

    this.httpClient.get<any>(url)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe((response) => {
        this.organizationList = response.data;
      });
  }

  onUserSubmit(submittedData, form) {
    const payload = submittedData;
    if (this.isUserCreate) {
      payload['created_by'] = this.authentication.userId;
      payload['userEmail'] = this.currentUserEmail;
      payload['userID'] = this.currentUserId;
      payload['userName'] = this.currentUserName;

      this.httpClient.post<any>(this.baseUrl + 'users', payload)
        .subscribe((response) => {
          if (response.code === 'success') {
            this.successmsg = true;
            this.messagecont = response.message;
            this.usersList.push(response.data);
            this.closeUser.nativeElement.click();
            form.reset();
            setTimeout(() => {
              this.successmsg = false;
            }, 2000);
          } else {
            this.warningmsg = true;
            this.messagecont = response.message;
          }
        });

    } else if (!this.isUserCreate && this.userId !== '') {
      payload['modified_by'] = this.authentication.userId;
      payload['userEmail'] = this.currentUserEmail;
      payload['userID'] = this.currentUserId;
      payload['userName'] = this.currentUserName;


      this.httpClient.put<any>(this.baseUrl + 'users?user_id=' + this.userId, payload)
        .subscribe((response) => {
          if (response.code === 'success') {
            this.successmsg = true;
            this.messagecont = response.message;
            this.closeUser.nativeElement.click();
            if (response.data) {
              response.data.filter((user) => {
                if (this.currentUserEmail === user.email) {
                  this.authentication.role = user.role_name;
                  this.currentUserRole = user.role_name;
                }
              });
            }
            this.usersList = response.data;
            form.reset();
            setTimeout(() => {
              this.successmsg = false;
            }, 2000);
          } else {
            this.warningmsg = true;
            this.messagecont = response.message;
          }
        });
    }
  }

  onRoleSubmit(submittedData, form) {
    const payload = submittedData;
    if (this.isRoleCreate) {
      payload['created_by'] = this.authentication.userId;
      payload['userEmail'] = this.currentUserEmail;
      payload['userID'] = this.currentUserId;
      payload['userName'] = this.currentUserName;

      this.httpClient.post<any>(this.baseUrl + 'roles', payload)
        .subscribe((response) => {
          if (response.code === 'success') {
            this.successmsg = true;
            this.messagecont = response.message;
            this.rolesList.push(response.data);
            this.closeRole.nativeElement.click();
            form.reset();
            setTimeout(() => {
              this.successmsg = false;
            }, 2000);
          } else {
            this.warningmsg = true;
            this.messagecont = response.message;
          }
        });

    } else if (!this.isRoleCreate && this.roleId !== '') {
      payload['modified_by'] = this.authentication.userId;
      payload['userEmail'] = this.currentUserEmail;
      payload['userID'] = this.currentUserId;
      payload['userName'] = this.currentUserName;

      this.httpClient.put<any>(this.baseUrl + 'roles?role_id=' + this.roleId, payload)
        .subscribe((response) => {
          if (response.code === 'success') {
            this.successmsg = true;
            this.messagecont = response.message;
            this.closeRole.nativeElement.click();
            this.rolesList = response.data;
            form.reset();
            setTimeout(() => {
              this.successmsg = false;
            }, 2000);
          } else {
            this.warningmsg = true;
            this.messagecont = response.message;
          }
        });
    }
  }

  addUser() {
    this.isUserCreate = true;
    this.enablePass = true;
    this.successmsg = false;
    this.warningmsg = false;
    const org_id = this.organizationList.length > 1 ? '' : this.organizationList[0].id;
    this.userData = { first_name: '', last_name: '', phone: '', email: '', org_name: '', username: '', role_id: '', status: true, org_id: org_id };
  }

  addRole() {
    this.isRoleCreate = true;
    this.successmsg = false;
    this.warningmsg = false;
    this.roleData = { user_role: '', description: '', status: true };
  }

  userEdit(userDetail) {
    this.isModalLoading = true;
    this.isUserCreate = false;
    this.enablePass = false;
    this.warningmsg = false;
    this.userId = userDetail.id;

    const url = `${this.baseUrl}users?user_id=${this.userId}&userDetails=${encodeURIComponent(JSON.stringify(this.userDetails))}`;
    this.httpClient.get<any>(url)
      .pipe(finalize(() => this.isModalLoading = false))
      .subscribe((response) => {
        if (response.code === 'success') {
          this.userData = response.data;
        }
      });

  }

  roleEdit(roleDetail) {
    this.isModalLoading = true;
    this.isRoleCreate = false;
    this.warningmsg = false;
    this.roleId = roleDetail.id;

    const url = `${this.baseUrl}roles?role_id=${this.roleId}&userDetails=${encodeURIComponent(JSON.stringify(this.userDetails))}`;
    this.httpClient.get<any>(url)
      .pipe(finalize(() => this.isModalLoading = false))
      .subscribe((response) => {
        if (response.code === 'success') {
          this.roleData = response.data;
        }
      });
  }

  deleteUser(user) {
    if (user.default) {
      this.dialog.open(ConfirmationdialogComponent, {
        maxWidth: '400px',
        data: {
          title: this.translate.instant('Sorry! You can\'t delete the <b>Super Admin</b> user.'),
          dialogType: 'warning',
          page: 'usermanagement-setup'
        }
      }).afterClosed().subscribe(() => { });
    } else if (user.email === this.currentUserEmail) {
      this.dialog.open(ConfirmationdialogComponent, {
        maxWidth: '400px',
        data: {
          title: this.translate.instant('Sorry! You can\'t delete currently loggedin user.'),
          dialogType: 'warning',
          page: 'usermanagement-setup'
        }
      }).afterClosed().subscribe(() => { });
    } else {
      this.dialog.open(ConfirmationdialogComponent, {
        maxWidth: '400px',
        data: {
          title: this.translate.instant('Are you sure you want to delete this User ?'),
          dialogType: 'confirmation',
          page: 'usermanagement-setup'
        }
      }).afterClosed().subscribe(result => {
        if (result) {

          const url = `${this.baseUrl}users?user_id=${user.id}&userDetails=${encodeURIComponent(JSON.stringify(this.userDetails))}`;
          this.httpClient.delete<any>(url)
            .pipe(finalize(() => this.isModalLoading = false))
            .subscribe((response) => {
              this.successmsg = true;
              this.messagecont = response.message;
              setTimeout(() => {
                this.successmsg = false;
              }, 2000);
              this.usersList = response.data;
            });
        }
      });
    }
  }

  deleteRole(role) {
    if (role.default) {
      this.dialog.open(ConfirmationdialogComponent, {
        maxWidth: '400px',
        data: {
          title: this.translate.instant('Sorry! You can\'t delete the <b>Super Admin</b> user role.'),
          dialogType: 'warning',
          page: 'usermanagement-setup'
        }
      }).afterClosed().subscribe(() => { });
    } else if (role.role === this.currentUserRole) {
      this.dialog.open(ConfirmationdialogComponent, {
        maxWidth: '400px',
        data: {
          title: this.translate.instant('Sorry! You can\'t delete currently loggedin user role.'),
          dialogType: 'warning',
          page: 'usermanagement-setup'
        }
      }).afterClosed().subscribe(() => { });
    } else {
      this.dialog.open(ConfirmationdialogComponent, {
        maxWidth: '400px',
        data: {
          title: this.translate.instant('Are you sure you want to delete this Role ?'),
          dialogType: 'confirmation',
          page: 'usermanagement-setup'
        }
      }).afterClosed().subscribe(result => {
        if (result) {

          const url = `${this.baseUrl}roles?role_id=${role.id}&userDetails=${encodeURIComponent(JSON.stringify(this.userDetails))}`;
          this.httpClient.delete<any>(url)
            .pipe(finalize(() => this.isModalLoading = false))
            .subscribe((response) => {
              this.successmsg = true;
              this.messagecont = response.message;
              setTimeout(() => {
                this.successmsg = false;
              }, 2000);
              this.rolesList = response.data;
            });
        }
      });
    }
  }


  savePermission(selectedPermissions) {
    const payload = [];
    let value;
    selectedPermissions.filter((data) => {
      value = {
        'role_id': data.id,
        'permissions': data.permissions,
        'userEmail': this.currentUserEmail,
        'userID': this.currentUserId,
        'userName': this.currentUserName
      };
      payload.push(value);
    });

    this.httpClient.put<any>(this.baseUrl + 'permissions', payload)
      .subscribe((response) => {
        if (response.code === 'success') {
          this.successmsg = true;
          this.messagecont = response.message;
          this.rolesList = response.data;
          setTimeout(() => {
            this.successmsg = false;
          }, 2000);
        }
      });
  }

  isValueTypeObject(data) {
    return this.utliService.isValueTypeObject(data);
  }

  public getPermissionName(tag: string): string {
    if (!Array.isArray(this.rolesList)) {
      return '';
    }

    const permissions = this.rolesList[0].permissions[tag];
    return permissions ? permissions.name : '';
  }
}
